import "./index.scss";

import React, { useEffect, useState } from "react";

import { useAppStore } from "../../../stores";
import type { AppData } from "../../../types/app-data.d";
import FeedbackForm from "../../feedback-form";

export default function Component() {
	const appStore = useAppStore((state) => state);

	const [navMenuList, setNavMenuList] = useState<Record<string, AppData["navMenuList"]["hits"]> | null>(null);

	useEffect(() => {
		if (appStore.navMenuList?.hits.length > 0) {
			setNavMenuList(
				appStore.navMenuList.hits
					.filter((item) => item.data.groups?.includes("footer"))
					.reduce((acc = {}, item) => {
						const key = item.data.category;
						acc[key] ??= [];
						acc[key].push(item);
						return acc;
					}, {})
			);
		}
	}, [appStore.navMenuList]);

	return (
		<div className="footer-top">
			<div className="container border-bottom border-white">
				<div className="footer-grid-layout">
					<div className="footer-navigation">
						<a className="footer-logo" href={appStore.sitePath?.[0].link ?? ""}>
							<img
								src={appStore.siteData?.logo}
								srcSet={appStore.siteData?.logoSrcset}
								sizes="(max-width: 768px) 180px, 360px"
								alt={appStore.phrases?.["logo"]}
								loading="lazy"
							/>
							<div>
								<h5>{appStore.siteData?.logoTitle}</h5>
								<p>{appStore.siteData?.logoSubtitle}</p>
							</div>
						</a>
						<nav className="nav">
							{navMenuList &&
								Object.entries(navMenuList).map(([category, items]) => (
									<div key={category} className={`footer-nav-block ${category == "undefined" ? "full" : ""}`}>
										{category != "undefined" && <h6 className="mb-1">{category}</h6>}
										{items.map(({ _id, displayName, data: { link, categoryLink } }) => (
											<a
												key={_id}
												className={`footer-nav-link ${appStore.currentPage === link ? "active" : ""}`}
												href={
													categoryLink ? `${appStore.sitePath?.[0].link}/climate-action?category=${categoryLink}` : link
												}
											>
												{displayName}
											</a>
										))}
									</div>
								))}
						</nav>
					</div>
					<FeedbackForm />
					<div className="contact">
						<div className="contact-item">
							<div className="d-flex align-items-center gap-1">
								<i className="fa-solid fa-phone me-2"></i>
								<span className="fw-bold">{appStore.phrases?.["phone"]}:</span>
							</div>
							<a href={`tel:${appStore.siteData?.phone}`}>{appStore.siteData?.phone}</a>
						</div>
						<div className="contact-item">
							<div className="d-flex align-items-center gap-1">
								<i className="fa-solid fa-envelope me-2"></i>
								<span className="fw-bold">{appStore.phrases?.["email"]}:</span>
							</div>
							<a href={`mailto:${appStore.siteData?.email}`}>{appStore.siteData?.email}</a>
						</div>
						<div className="contact-item">
							<div className="d-flex align-items-center gap-1">
								<i className="fa-solid fa-location-dot me-2"></i>
								<span className="fw-bold">{appStore.phrases?.["address"]}:</span>
							</div>
							<span>{appStore.siteData?.address}</span>
						</div>
						<div className="d-flex gap-2 mt-3 mt-md-0 mb-3">
							<a href={appStore.siteData?.instagram} className="fs-2">
								<i className="fa-brands fa-instagram"></i>
							</a>
							<a href={appStore.siteData?.facebook} className="fs-2">
								<i className="fa-brands fa-facebook"></i>
							</a>
							<a href={appStore.siteData?.whatsapp} className="fs-2">
								<i className="fa-brands fa-whatsapp"></i>
							</a>
							<a href={appStore.siteData?.telegram} className="fs-2">
								<i className="fa-brands fa-telegram"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
